import { Fragment } from 'react'
import { Link } from 'react-router-dom'
import type { ApiStorageNode } from '@/types/storage'

/**
 * Storage › unit › rack › … › selection. Replaces the unit switcher and the
 * "Showing" picker: every crumb is a way back up, and the last one says where
 * you are.
 */
export function UnitBreadcrumb({
  listHref,
  crumbs,
  onJump,
}: {
  /** Where "Storage" goes — the list the user came from. */
  listHref: string
  /** Root first, ending with the selection. */
  crumbs: ApiStorageNode[]
  onJump: (node: ApiStorageNode) => void
}) {
  return (
    <nav aria-label='Breadcrumb' className='flex flex-wrap items-center gap-1 text-sm text-muted-foreground'>
      <Link to={listHref} className='rounded-md px-1.5 py-0.5 hover:bg-muted hover:text-foreground'>
        Storage
      </Link>
      {crumbs.map((crumb, i) => {
        const current = i === crumbs.length - 1
        // The unit goes by its code, as in the header; racks and boxes by
        // the name someone gave them, when they have one.
        const label = i === 0 ? crumb.code : (crumb.name ?? crumb.code)
        return (
          <Fragment key={crumb.id}>
            <span aria-hidden>›</span>
            {current ? (
              <span aria-current='page' className='rounded-md bg-muted px-1.5 py-0.5 font-semibold text-foreground'>
                {label}
              </span>
            ) : (
              <button
                type='button'
                onClick={() => onJump(crumb)}
                className='rounded-md px-1.5 py-0.5 hover:bg-muted hover:text-foreground'
              >
                {label}
              </button>
            )}
          </Fragment>
        )
      })}
    </nav>
  )
}
